<template>
  <div class="product-page">
    <Button type="primary" icon="plus-round" v-if="permissions === true" @click="edit(-1)">{{$t('Product.New_Product')}}</Button>
    <Button type="primary" icon="plus-round" v-if="permissions !== true" @click="edit(-1)" disabled>{{$t('Product.New_Product')}}</Button>
    <Input class="info" v-model="search" :placeholder="$t('Product.productNo')">
           <Button slot="append" icon="ios-search" @click="handleSearch()"></Button>
           <Button slot="append" icon="refresh" @click="handleReset()"></Button>
        </Input>
    <Table class="product-table" highlight-row stripe border :columns="columns" :data="datas"></Table>
  </div>
</template>
<script>
import { Api } from '@/api'
export default {
  name: 'Product',
  data () {
    return {
      columns: [
        { type: 'index', title: this.$t('Product.index'), width: 70 },
        { title: this.$t('Product.productNo'), key: 'productNo' },
        { title: this.$t('Product.name'), key: 'name', sortable: true, sortType: 'asc' },
        { title: this.$t('Product.latDensity'), key: 'latDensity', sortable: true },
        // { title: '密度', key: 'density' },
        { title: this.$t('Product.kaidu'), key: 'kaidu', sortable: true },
        { title: this.$t('Product.width'), key: 'width', sortable: true },
        // { title: '耗损率', key: 'attritionRate' },
        { title: this.$t('Product.specifications'), key: 'specifications' },
        // {
        //   title: '图片',
        //   key: 'image',
        //   render: (h, params) => {
        //     return h('img', {
        //       attrs: {
        //         src: params.row.image
        //       },
        //       style: {
        //         width: '100%',
        //         margin: '2px 0px',
        //         'vertical-align': 'middle'
        //       }
        //     })
        //   }
        // },
        {
          title: this.$t('Product.valid'),
          key: 'valid',
          render: (h, params) => {
            let s = params.row.valid === 1 ? this.$t('Product.yes') : this.$t('Product.no')
            return h('span', s)
          }
        },
        {
          title: this.$t('Product.action'),
          key: 'action',
          render: (h, params) => {
            if (this.permissions === true) {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small'
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      this.edit(params.index)
                    }
                  }
                }, this.$t('Product.edit')),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  },
                  on: {
                    click: () => {
                      if (confirm(this.$t('Product.delete_message'))) {
                        this.remove(params.index)
                      }
                    }
                  }
                }, this.$t('Product.delete'))
              ])
            } else {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: true
                  },
                  style: {
                    marginRight: '5px'
                  }
                }, this.$t('Product.edit')),
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small',
                    disabled: true
                  }
                }, this.$t('Product.delete'))
              ])
            }
          }
        }
      ],
      datas: [],
      productList: [],
      search: '',
      permissions: false
    }
  },
  computed: {
  },
  methods: {
    edit (index) {
      let id = index === -1 ? 0 : this.datas[index].id
      this.$router.push({ name: 'ProductEdit', params: { id } })
    },
    remove (index) {
      this.$api.product.delete(this.datas[index].id).then(() => {
        this.datas.splice(index, 1)
      })
    },
    handleSearch () {
      this.datas = []
      for (let i = 0; i < this.productList.length; i++) {
        let p = this.productList[i]
        if (p.productNo.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
          this.datas.push(p)
        }
      }
    },
    handleReset () {
      this.datas = this.productList
    }
  },
  mounted () {
    Api.user.fetchUserInfo().then(res => {
      for (let i = 0; i < res.user.permissions.length; i++) {
        if (res.user.permissions[i].action === 'product' && res.user.permissions[i].value === 3) {
          this.permissions = true
        }
      }
    })
  },
  beforeRouteEnter (to, from, next) {
    Api.product.list().then(res => {
      next(vm => {
        let d = []
        vm.datas = res.products
        vm.productList = res.products
        for (let i = 0; i < vm.datas.length; i++) {
          if (vm.datas[i].valid === 1 || vm.datas[i].valid === 2) {
            d.push(vm.datas[i])
          }
        }
        vm.datas = d
      })
    })
  }
}
</script>
<style>
.product-page {
  padding: 10px;
}
.info {
    width: 33.33333%
}
.product-table {
  margin-top: 20px;
}
</style>





// WEBPACK FOOTER //
// List.vue?7cad17b8